import type { MouseEventHandler, ReactElement, ReactNode } from "react";
import { motion } from "framer-motion";
import { TOOLTIP_ENTER_EXIT_TRANSITION } from "./ctooltip-constants";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface CtooltipMotionProps {
    dataElScope: DataElScope;
    children: ReactNode;
    exitYOffset: number;
    onMouseEnter: MouseEventHandler<HTMLDivElement>;
    onMouseLeave: MouseEventHandler<HTMLDivElement>;
}
export function CtooltipMotion({ dataElScope, children, exitYOffset, onMouseEnter, onMouseLeave, }: CtooltipMotionProps): ReactElement {
    return (
      <motion.div data-el={dataEl(dataElScope, "Motion/Root")} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} initial={false} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: exitYOffset }} transition={TOOLTIP_ENTER_EXIT_TRANSITION}>
        {children}
      </motion.div>
    );
}
